import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { lazyReadOcsSettings } from "owa-ocs-service-gql";

export default async function getShowPreviewLinesInListViewOCSSetting(): Promise<number | null> {
    const showPreviewLinesInListView = await lazyReadOcsSettings.importAndExecute(getGlobalSettingsAccountMailboxInfo(), "ACCOUNT", ["mail_showpreviewlinesinlistview"]);
    
    if (!showPreviewLinesInListView?.[0]) {
        return null;
    }
    
    try {
        const parsedValue = JSON.parse(showPreviewLinesInListView[0].value);
        return typeof parsedValue === "number" ? parsedValue : null;
    }
    catch {
        return null;
    }
}
